@if (saleInformationEnabled$ | async) {
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>Sale Price Breakdown</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
            <div class="tw:pt-2 tw:text-sm">Median Price:</div>
            <div class="tw:text-lg tw:font-bold">{{ medianSalePrice | redCurrency }}</div>
          </ion-col>
          <ion-col size="6" class="tw:flex tw:flex-col tw:items-end">
            <div class="tw:pt-2 tw:text-sm">Highest Sale Price:</div>
            <div class="tw:text-lg tw:font-bold">
              {{ maxSalePrice | redCurrency }}
              <ion-icon name="caret-up-outline" color="success"></ion-icon>
            </div>
            <div class="tw:pt-2 tw:text-sm">Lowest Sale Price:</div>
            <div class="tw:text-lg tw:font-bold">
              {{ minSalePrice | redCurrency }}
              <ion-icon name="caret-down-outline" color="danger"></ion-icon>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>12 Months Sale History</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="tw:mb-2 tw:flex tw:gap-2 tw:pt-2 tw:text-sm">
        <div class="tw:flex-auto tw:text-center">
          All Properties: <b>{{ this.walkingFarm?.properties?.length | redDashIfEmpty }}</b>
        </div>
        <div class="tw:flex-auto tw:text-center">
          Sold In Last 12 Months: <b>{{ this.totalSalesInLast12Months | redDashIfEmpty }}</b>
        </div>
      </div>
      @if (turnoverRateEnabled) {
        <div class="tw:relative tw:h-32">
          <red-chart [options]="turnoverChartOptions"></red-chart>
        </div>
      }
    </ion-card-content>
  </ion-card>
}
<ion-card>
  <ion-card-header>
    <ion-card-subtitle>Neighborhood Snapshot</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="tw:relative tw:h-32">
      <red-chart [options]="ownerOccupiedChartOptions"></red-chart>
    </div>
    <ion-grid class="ion-no-padding tw:mt-4">
      <ion-row>
        <ion-col size="6" class="tw:border-r-solid tw:border-r tw:border-gray-200">
          <div class="tw:pt-2 tw:text-sm">Median FSF:</div>
          <div class="tw:text-lg tw:font-bold">{{ medianBuildingArea | redSurface }}</div>
        </ion-col>
        <ion-col size="6" class="tw:flex tw:justify-end">
          <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
            <ion-icon src="/assets/svg/bedroom.svg" size="large"></ion-icon>
            <div>{{ medianBedrooms | redDashIfEmpty }} Bed</div>
          </div>
          <div class="tw:flex tw:w-16 tw:flex-col tw:items-center tw:justify-between tw:px-2 tw:align-middle">
            <ion-icon src="/assets/svg/bathroom.svg" size="large"></ion-icon>
            <div>{{ medianBathrooms | redDashIfEmpty }} BA</div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
<ion-button class="tw:m-4" expand="block" (click)="renameFarm()">
  Rename Farm<ion-icon slot="start" name="pencil-outline"></ion-icon>
</ion-button>
<ion-button class="tw:m-4" expand="block" (click)="exportFarm()">
  Export Farm<ion-icon slot="start" name="share-outline"></ion-icon>
</ion-button>
